import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import EnhancedAuthForm from './EnhancedAuthForm';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAuthSuccess: () => void;
}

const AuthModal = ({ isOpen, onClose, onAuthSuccess }: AuthModalProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Auto-focus email input when modal opens
  useEffect(() => {
    if (isOpen && !user) {
      const timer = setTimeout(() => {
        const emailInput = document.getElementById('signin-email');
        emailInput?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isOpen, user]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md border-0 bg-background/95 backdrop-blur p-0 overflow-hidden">
        <DialogHeader>
          <DialogTitle className="sr-only">Authentication</DialogTitle>
        </DialogHeader>
        {user ? (
          <div className="flex flex-col items-center gap-4 p-8 text-center">
            <p className="text-foreground font-medium">You're already signed in</p>
            <Button onClick={() => { onClose(); navigate('/dashboard'); }} className="w-full">
              Go to Dashboard
            </Button>
          </div>
        ) : (
          <EnhancedAuthForm onSuccess={onAuthSuccess} onClose={onClose} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
